import { Button, Card, CardActions, CardContent, CardHeader, Divider, Modal, Snackbar } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import AddIcCallIcon from '@material-ui/icons/AddIcCall';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { deviceType } from 'react-device-detect';
import { connect } from 'react-redux';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import logger from 'src/utils/logger';
const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 700,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  actions: {
    justifyContent: 'flex-end'
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  }
}));
function FgsArama({ open, onClose, FisNo, tasks, className }) {
  const classes = useStyles();
  const [LoadingControl, setLoadingControl] = useState(false);
  const [responseMessage, setresponseMessage] = useState({ ErrorCode: "0", ErrorDescription: "İşleminiz başarı ile gerçekleştirildi." });
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  let AramaData = [];
  if (tasks.tasks !== "") {
    AramaData = tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo));
  }

  if (!open) {
    return null;
  }

  const SessionUser = getUser();

  const handleFgsAramaYap = (event, Telefon, tip, FisNo, Musteri, TelefonOffline) => {
    var Kontrol = window.navigator.onLine ? 1 : 0;




    var Uyari = "Merhaba " + SessionUser.FirstName + ", seni hemen servisinize ait telefon numarasından arayacağım, sonra müşterimiz ";
    Uyari += Musteri + " ın " + Telefon + " numaralı telefonuna bağlayacağım. Aramayı başlatmamı ister misin?";
    var UyariAlert = "Müşterimiz " + Musteri + " ın " + Telefon + " numaralı telefonu için arama başlatıldı.";

    const confirmation = window.confirm(Uyari)
    if (!confirmation) {
      return;
    }

    if (SessionUser.TopServiceShopName === 'KIBRIS BY') {
      setresponseMessage({ ErrorCode: "0", ErrorDescription: "Arama Başarılı!..." });
      setUyariTip("success");
      setUyari(true);
      setLoadingControl(false);
      const phoneNumber = "0" + TelefonOffline;
      window.open(`tel:${phoneNumber}`, '_self');
      alert(UyariAlert);
      return;
    }

    setLoadingControl(true);
    // Online 1 Offline 0 = Kontrol
    if (SessionUser.MobileNumber === "4440888") {
      setresponseMessage({ ErrorCode: "10", ErrorDescription: "Arama yapabilmeniz için önce telefon numaranızı giriş ekranından kaydediniz!..." });
      setUyariTip("error");
      setUyari(true);
      setLoadingControl(false);
      return;
    }

    if (deviceType === "tablet" && Kontrol === 0) {
      setresponseMessage({ ErrorCode: "0", ErrorDescription: "Tabletten arama yapabilmeniz için online olmanız gerekiyor!..." });
      setUyariTip("error");
      setUyari(true);
      setLoadingControl(false);
      return;
    }

    if (deviceType === "tablet" || Kontrol === 1) {
      axios.get(`/GetArcloudDialRequest/${SessionUser.ServiceShopCode}/${tip}/${FisNo}/${SessionUser.UserId}`)
        .then(() => {
          setLoadingControl(false);
          alert(UyariAlert);
        }).catch(error => {
          setLoadingControl(false);
          alert(UyariAlert);
                logger.error("Hata detayı:", error.message);
        });

    } else {
      setresponseMessage({ ErrorCode: "0", ErrorDescription: "Arama Başarılı!..." });
      setUyariTip("success");
      setUyari(true);
      setLoadingControl(false);
      const phoneNumber = "08507591180,0" + TelefonOffline;
      window.open(`tel:${phoneNumber}`, '_self');
      alert(UyariAlert);
    }

  }
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const getTitle = (event) => {
    return event[0]?.FisNo + " " + event[0]?.Musteri;
  }

  const getTitle1 = (event) => {
    return event[0]?.BasvuruNedeni;
  }

  return (
    <Modal
      onClose={onClose}
      open={open}
    >
      <Card className={clsx(classes.root, className)} >
        <form>
          <CardHeader title={getTitle(AramaData)}
          style={{ fontFamily: 'Arcelik', fontWeight: 'bold' }}
          subheader={getTitle1(AramaData)}
          />
          
          <Divider />
          <CardContent>
            {
              LoadingControl ?
                <CircularProgress
                  status={'loading'}
                  style={{ marginLeft: '50%' }}
                />
                : <div></div>
            }
            <div>
              <div className={classes.wrapper}>
                {
                  AramaData[0]?.Telefon !== "" ?
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.submitButton}
                      onClick={(event) => handleFgsAramaYap(event, AramaData[0]?.Telefon, 1, AramaData[0]?.FisNo, AramaData[0]?.Musteri, AramaData[0]?.TelefonOffline)}
                      endIcon={<AddIcCallIcon>Call</AddIcCallIcon>}>
                      {AramaData[0]?.Telefon}
                    </Button>
                    : <div></div>
                }
              </div>
              <div className={classes.wrapper}>
                {
                  AramaData[0]?.Telefon2 !== "" ?
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.submitButton}
                      onClick={(event) => handleFgsAramaYap(event, AramaData[0]?.Telefon2, 2, AramaData[0]?.FisNo, AramaData[0]?.Musteri, AramaData[0]?.Telefon2Offline)}
                      endIcon={<AddIcCallIcon>Call</AddIcCallIcon>}>
                      {AramaData[0]?.Telefon2}
                    </Button>
                    : <div></div>
                }
              </div>
              <div className={classes.wrapper}>
                {
                  AramaData[0]?.Telefon3 !== "" ?
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.submitButton}
                      onClick={(event) => handleFgsAramaYap(event, AramaData[0]?.Telefon3, 3, AramaData[0]?.FisNo, AramaData[0]?.Musteri, AramaData[0]?.Telefon3Offline)}
                      endIcon={<AddIcCallIcon>Call</AddIcCallIcon>}>
                      {AramaData[0]?.Telefon3}
                    </Button>
                    : <div></div>
                }
              </div>
              <div className={classes.wrapper}>
                {
                  AramaData[0]?.ArayanTelefon !== "" ?
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.submitButton}
                      onClick={(event) => handleFgsAramaYap(event, AramaData[0]?.ArayanTelefon, 4, AramaData[0]?.FisNo, AramaData[0]?.Musteri, AramaData[0]?.ArayanTelefonOffline)}
                      endIcon={<AddIcCallIcon>Call</AddIcCallIcon>}>
                      ArayanTelefon : {AramaData[0]?.ArayanTelefon}
                    </Button>
                    : <div></div>
                }
              </div>
              <div className={classes.wrapper}>
                {
                  AramaData[0]?.IrtibatTelefon !== "" ?
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.submitButton}
                      onClick={(event) => handleFgsAramaYap(event, AramaData[0]?.IrtibatTelefon, 5, AramaData[0]?.FisNo, AramaData[0]?.Musteri, AramaData[0]?.IrtibatTelefonOffline)}
                      endIcon={<AddIcCallIcon>Call</AddIcCallIcon>}>
                      IrtibatTelefon : {AramaData[0]?.IrtibatTelefon}
                    </Button>
                    : <div></div>
                }
              </div>
            </div>
            <Snackbar open={uyari} onClose={uyariKapat} autoHideDuration={5000}>
              <Alert onClose={uyariKapat} message={responseMessage.ErrorDescription} variant={uyariTip} />
            </Snackbar>
          </CardContent>
          <Divider />
          <CardActions className={classes.actions}>
            <Button
              variant="contained"
              color="secondary"
              onClick={onClose}>
              Kapat
            </Button>
          </CardActions>
        </form>
      </Card>
    </Modal>
  );
}

FgsArama.propTypes = {
  className: PropTypes.string,
  FisNo: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool
};

FgsArama.defaultProps = {
  open: false,
  onClose: () => { }
};

export default connect(
  state => ({ tasks: state.tasks1 })
)(FgsArama);
